import {
	AuthorizationsEnum,
	ChangePlanEnum,
	ExamBookingEnum,
	GuidesEnum,
	HealthBookingEnum,
	OdontoBookingEnum,
	ProfileEnum,
	TelehealthBookingEnum,
} from 'presentation/constants';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {CHANGE_PLAN_LOCATION_FLOW, FlowTypeEnum, LocationSelectionFlowEnum} from './flowType';

function getContactPath(type: FlowTypeEnum) {
	const flowType: Record<Exclude<FlowTypeEnum, FlowEnum.SURGERY>, string> = {
		HEALTH: HealthBookingEnum.HEALTH_BOOKING_CONTACT,
		TELEHEALTH: TelehealthBookingEnum.TELEHEALTH_BOOKING_CONTACT,
		ODONTO: OdontoBookingEnum.ODONTO_BOOKING_CONTACT,
		EXAM: ExamBookingEnum.EXAM_BOOKING_CONTACT,
		AUTHORIZATIONS: AuthorizationsEnum.REQUEST_INITIAL_FLOW_CONTACT,
	};
	return flowType[type];
}

function getEmailPath(type: FlowTypeEnum) {
	const flowType: Record<Exclude<FlowTypeEnum, FlowEnum.SURGERY>, string> = {
		HEALTH: HealthBookingEnum.HEALTH_BOOKING_EMAIL,
		TELEHEALTH: TelehealthBookingEnum.TELEHEALTH_BOOKING_EMAIL,
		ODONTO: OdontoBookingEnum.ODONTO_BOOKING_EMAIL,
		EXAM: ExamBookingEnum.EXAM_BOOKING_EMAIL,
		AUTHORIZATIONS: AuthorizationsEnum.REQUEST_INITIAL_FLOW_EMAIL,
	};
	return flowType[type];
}

function getUfPath(type: LocationSelectionFlowEnum) {
	const flowType: Record<
		Exclude<LocationSelectionFlowEnum, FlowEnum.SURGERY>,
		string
	> = {
		HEALTH: HealthBookingEnum.HEALTH_BOOKING_UF,
		TELEHEALTH: TelehealthBookingEnum.TELEHEALTH_BOOKING_UF,
		ODONTO: OdontoBookingEnum.ODONTO_BOOKING_UF,
		EXAM: ExamBookingEnum.EXAM_BOOKING_UF,
		AUTHORIZATIONS: AuthorizationsEnum.REQUEST_INITIAL_FLOW_UF,
		HEALTH_GUIDE: GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_UF,
		ODONTO_GUIDE: GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_UF,
		[CHANGE_PLAN_LOCATION_FLOW]: ChangePlanEnum.CHANGE_PLAN_NEW_PLAN_UF,
	};
	return flowType[type];
}

function getCityPath(type: LocationSelectionFlowEnum) {
	const flowType: Record<
		Exclude<LocationSelectionFlowEnum, FlowEnum.SURGERY>,
		string
	> = {
		HEALTH: HealthBookingEnum.HEALTH_BOOKING_CITY,
		TELEHEALTH: TelehealthBookingEnum.TELEHEALTH_BOOKING_CITY,
		ODONTO: OdontoBookingEnum.ODONTO_BOOKING_CITY,
		EXAM: ExamBookingEnum.EXAM_BOOKING_CITY,
		AUTHORIZATIONS: AuthorizationsEnum.REQUEST_INITIAL_FLOW_CITY,
		HEALTH_GUIDE: GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_CITY,
		ODONTO_GUIDE: GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_CITY,
		[CHANGE_PLAN_LOCATION_FLOW]: ChangePlanEnum.CHANGE_PLAN_NEW_PLAN_CITY,
	};
	return flowType[type];
}

function getInitialPath(type: FlowEnum | typeof CHANGE_PLAN_LOCATION_FLOW) {
	const flowType: Record<Exclude<FlowEnum, FlowEnum.SURGERY> | typeof CHANGE_PLAN_LOCATION_FLOW, string> = {
		HEALTH: HealthBookingEnum.HEALTH_BOOKING_INITIAL,
		TELEHEALTH: TelehealthBookingEnum.TELEHEALTH_BOOKING_INITIAL,
		ODONTO: OdontoBookingEnum.ODONTO_BOOKING_INITIAL,
		EXAM: ExamBookingEnum.EXAM_BOOKING_INITIAL,
		PROFILE: ProfileEnum.PROFILE,
		AUTHORIZATIONS: AuthorizationsEnum.REQUEST,
		HEALTH_GUIDE: GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_DISTRICT,
		ODONTO_GUIDE: GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_DISTRICT,
		[CHANGE_PLAN_LOCATION_FLOW]: ChangePlanEnum.CHANGE_PLAN_NEW_PLAN,
	};
	return flowType[type];
}

function getBookingFlowPath(type: FlowTypeEnum) {
	const flowType: Record<Exclude<FlowTypeEnum, FlowEnum.SURGERY>, string> = {
		HEALTH: HealthBookingEnum.HEALTH_BOOKING_FLOW,
		TELEHEALTH: TelehealthBookingEnum.TELEHEALTH_BOOKING_FLOW,
		ODONTO: OdontoBookingEnum.ODONTO_BOOKING_FLOW,
		EXAM: ExamBookingEnum.EXAM_BOOKING_FLOW,
		AUTHORIZATIONS: AuthorizationsEnum.REQUEST,
	};
	return flowType[type];
}

function getLocalityPath(type: LocationSelectionFlowEnum) {
	if (type !== FlowEnum.EXAM && type !== FlowEnum.HEALTH) return '';

	const flowType: Partial<Record<FlowTypeEnum, string>> = {
		HEALTH: HealthBookingEnum.HEALTH_BOOKING_LOCALITY,
		EXAM: ExamBookingEnum.EXAM_BOOKING_LOCALITY,
	};
	return flowType[type];
}

export {
	getContactPath,
	getBookingFlowPath,
	getCityPath,
	getUfPath,
	getInitialPath,
	getEmailPath,
	getLocalityPath,
};
